export default {
    getAll(style = 'default') {
        return new Promise((resolve, reject) => {
            http.get('api/categories').then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    fetchRecords(body) {
        return new Promise((resolve, reject) => {
            http.post('api/categories/list', {
                page: body.page,
                search: body.search,
                length: body.pageLength,
                order: [{'column': body.orderColumn, 'dir': body.orderAsc ? 'asc' : 'desc'}],
                filter: body.filter
            }).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    saveDocumentTemplateCategory(data) {
        return new Promise((resolve, reject) => {
            http.post('api/categories' + (data.id ? '/' + data.id : ''), data).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },
}
